<template>
    <v-card xs12>

        <v-toolbar>
            <DatesPicker v-model="selectedDateRange"></DatesPicker>
            <v-divider vertical style="margin-left: 8px; margin-right: 8px"></v-divider>
            <StudentPickerAutocomplete
                :useQueryString="true"
                v-model="selectedStudentId"
            >
            </StudentPickerAutocomplete>

        </v-toolbar>

        <v-card-text>
            <AssessmentHistoryChart
                    :studentId="selectedStudentId"
                    :maxNumEntries="maxNumEntries"
                    :startDate="selectedDateRange ? selectedDateRange.startDate : undefined"
                    :endDate="selectedDateRange ? selectedDateRange.endDate : undefined"
            ></AssessmentHistoryChart>
        </v-card-text>
    </v-card>
</template>

<script>
    import AssessmentHistoryChart from "./AssessmentHistoryChart";
    import StudentPickerAutocomplete from "@/components/StudentPickerAutocomplete.vue";
    import DatesPicker from "@/components/DatesPicker.vue"

    export default {
        name: "StudentAssessmentHistory",
        components: {StudentPickerAutocomplete, AssessmentHistoryChart, DatesPicker},
        data: function () {
            let routeStudentId = +this.$router.currentRoute.query['studentId'];
            return {
                selectedDateRange: {
                    startDate: undefined,
                    endDate: undefined,
                },

                maxNumEntries: 5,
                studentId: routeStudentId,
                selectedStudentId: routeStudentId,
            }
        },

        methods: {
        },
        mounted() {
            // set toolbar title
            this.$store.commit('setToolbarOptions', {
                title: 'Test History',
                subTitle: '',
                hideSearch: false,
                backButtonRoute: {name: 'reports', query: isNaN(this.selectedStudentId) ?
                        {} :
                        {studentId: this.selectedStudentId}
                }
            });
        }
    }
</script>

<style scoped>

</style>
